export const isWorkerThread = () => self.document === undefined;
export const str2ab = str => {
  var uint8array = new TextEncoder().encode(str);
  return uint8array;
};
export const ab2str = (uint8array, encoding = 'utf-8') => {
  var str = new TextDecoder(encoding).decode(uint8array);
  return str;
};